import App from './App';

const { Provider } = reactRedux;

export default class RootComponent extends React.PureComponent {
  render() {
    return (
      <Provider store={this.props.store}>
        <App />
      </Provider>
    );
  }
}
